let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6mjPT")).then(() => parcelRequire('3sE2m'));